export default (that) => [
  {
    text: that.$l('btn_label_view') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
    showMenu: () => true,
  },
  {
    text: that.$l('btn_label_edit') || '编辑数据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    showMenu: ({ platformStatus }) => platformStatus === 'C',
  },
  {
    text: that.$l('btn_label_delete') || '删除数据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    showMenu: ({ platformStatus }) => platformStatus === 'C',
  },
  {
    text: that.$l('btn_label_submit') || '提交审核',
    icon: 'el-icon-circle-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    data: {},
    showMenu: ({ platformStatus }) => platformStatus === 'C',
  },
  {
    text: that.$l('btn_label_review_edit') || '审核修改',
    icon: 'el-icon-edit-outline',
    menuType: 'review',
    divided: true,
    allow: 'C',
    data: {},
    showMenu: ({ platformStatus }) => platformStatus === 'Y',
  },
]
